import { HsVector2 } from '../../math-new/objects/vector2.class';
import type { HsControlActionType } from './control-action-type.enum';
import { HsControlAction } from './control-action.abstract';

export class HsMouseMoveControlAction extends HsControlAction {
  constructor(public actionType: HsControlActionType, public delta: HsVector2 = new HsVector2(0, 0)) {
    super();
  }

  public getValuesFrom(controlAction: HsControlAction): void {
    if (!(controlAction instanceof HsMouseMoveControlAction)) {
      return;
    }

    // Several pointers can move within one frame (for example a two-finger pan), so pending deltas add up.
    if (this.isActive) {
      this.delta.add(controlAction.delta);
    } else {
      this.delta.copy(controlAction.delta);
    }
    this.isActive = true;
  }
}
